import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";

import { Container, Row, Col } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import Preview from "./Preview";
import GKEvent from "../events";
import SelectHeaderFooter from "../core/functions/SelectHeaderFooter";

import Switch from "@material-ui/core/Switch";
import { ajaxUri } from "../consts/index";

import Frame from "./Frame";
import { l } from "../functions";

const mapStateToProps = (state) => {
  return {
    fetchedPayloads: state.rootReducer.fetchedPayloads || {},
    fetchedMenu: state.rootReducer.fetchedMenu || [],
    currentDevice: state.rootReducer.currentDevice || "xl",
    currentPage: state.rootReducer.currentPage || "home",
    elementToEdit: state.rootReducer.elementToEdit || null,
    appearanceSettings: state.rootReducer.appearanceSettings || {},
    header: state.rootReducer.header || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editElement: () => dispatch({ type: "EDIT_ELEMENT", element: "header" }),
    setHeaderData: (headerData) =>
      dispatch({ type: "SET_HEADER_DATA", header: headerData }),
  };
};
class HeaderFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      type: "none",
      html: l("Please wait..."),
      active: false,
    };

    GKEvent.addEventListener("updateActiveHeader", (target, active) => {
      if (
        this.props.element === target ||
        (this.props.element === "top_bar" && target === "header")
      )
        this.setState({
          active: active,
        });
    });

    GKEvent.addEventListener("updateHeaderFooter", (type, html) => {
      if (this.state.type !== type) {
        this.setState({
          type: type || "none",
          html: html || "",
        });
      }
    });

    this.headerHeights = {
      default: {
        xs: 80,
        sm: 80,
        md: 150,
        lg: 150,
        xl: 150,
      },
      groovezone: {
        xs: 122,
        sm: 122,
        md: 124,
        lg: 124,
        xl: 124,
      },
      groovebook: {
        xs: 77,
        sm: 77,
        md: 153,
        lg: 153,
        xl: 153,
      },
      awesome: {
        xs: 77,
        sm: 77,
        md: 153,
        lg: 153,
        xl: 153,
      },
      dropship: {
        xs: 86,
        sm: 86,
        md: 86,
        lg: 86,
        xl: 86,
      },
      luxury: {
        xs: 66,
        sm: 66,
        md: 123,
        lg: 123,
        xl: 123,
      },
      header1: {
        xs: 66,
        sm: 66,
        md: 123,
        lg: 123,
        xl: 123,
      },
      header2: {
        xs: 66,
        sm: 66,
        md: 123,
        lg: 123,
        xl: 123,
      },
      header3: {
        xs: 66,
        sm: 66,
        md: 123,
        lg: 123,
        xl: 123,
      },
      header5: {
        xs: 66,
        sm: 66,
        md: 123,
        lg: 123,
        xl: 123,
      },
      header6: {
        xs: 66,
        sm: 66,
        md: 70,
        lg: 70,
        xl: 70,
      },
      header7: {
        xs: 66,
        sm: 66,
        md: 123,
        lg: 123,
        xl: 123,
      },
      header8: {
        xs: 66,
        sm: 66,
        md: 113,
        lg: 113,
        xl: 113,
      },
      header9: {
        xs: 83,
        sm: 83,
        md: 73,
        lg: 73,
        xl: 73,
      },
      header10: {
        xs: 66,
        sm: 66,
        md: 123,
        lg: 123,
        xl: 123,
      },
      header11: {
        xs: 100,
        sm: 100,
        md: 123,
        lg: 200,
        xl: 165,
      },
      header12: {
        xs: 173,
        sm: 153,
        md: 153,
        lg: 153,
        xl: 153,
      },
      header13: {
        xs: 66,
        sm: 66,
        md: 66,
        lg: 66,
        xl: 66,
      },
    };

    this.targetLabels = {
      top_bar: l("Top Bar"),
      footer: l("Footer"),
      header: l("Header"),
    };

    this.notAllowedPages = ["top_bar", "footer", "modal"];
  }

  componentDidMount() {
    if (
      this.props.header.type &&
      this.props.header.html &&
      this.props.target === "header"
    ) {
      this.setState({
        type: this.props.header?.type,
        html: this.props.header?.html,
      });
    }
    this._setType();
    this._setActive("home");
  }

  componentWillReceiveProps({ currentPage, fetchedMenu, header, target }) {
    // console.log("prop changed", target);
    if (currentPage !== this.props.currentPage) this._setActive(currentPage);

    if (
      fetchedMenu != null &&
      JSON.stringify(fetchedMenu) !== JSON.stringify(this.props.fetchedMenu)
    ) {
    }
    // this._setType();
    this.setState({ type: header?.type, html: header?.html || "" });
  }

  _setType = () => {
    const {
      showSearch,
      showLogin,
      header_background_color,
      header_link_color,
      header_link_font,
    } = this.props.appearanceSettings;

    if (this.props.element === "header") {
      if (!this.state.type || this.state.type === "none") {
        // console.log("setHeaderType");

        axios({
          method: "post",
          url: ajaxUri,
          data: {
            request: "getHeaderFooterType",
            element: this.props.element,
            demo: false,
            setting: JSON.stringify({
              showSearch: showSearch,
              showLogin: showLogin,
              linkFont: header_link_font,
              background: header_background_color,
              linkColor: header_link_color,
            }),
          },
        })
          .then((result) => {
            this.setState(
              {
                type: result.data.result || "none",
                html: result.data.content || "",
              },
              () => {
                this.props.setHeaderData({
                  ...this.props.header,
                  ...this.state,
                });
              }
            );
          })
          .catch((error) => {
            console.error("Error ajax");
          });
      }
    }
  };

  _setActive = (currentPage) => {
    const targetElement =
      this.props.element === "top_bar" ? "header" : this.props.element;

    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getHeaderFooterActive",
        element: targetElement,
        pageid: currentPage,
      },
    })
      .then((result) => {
        GKEvent.updateActiveHeader(targetElement, result.data ? true : false);
      })
      .catch((error) => {
        console.error("Error ajax");
      });
  };

  _toggleDialog = (status, value = this.state.type) => {
    this.setState(
      {
        open: status,
      },
      () => {
        if (!status && this.state.type !== value) {
          axios({
            method: "post",
            url: ajaxUri,
            data: {
              request: "updateHeaderFooterType",
              element: this.props.element,
              type: value,
              demo: false,
            },
          })
            .then((result) => {
              if (result.data.status === "success")
                this.setState({ type: value, html: result.data.html });

              GKEvent.notification(result.data.status, result.data.message);
            })
            .catch((error) => {
              console.error("Error ajax");
            });
        }
      }
    );
  };

  _changedActive = (event) => {
    const targetElement = this.props.element;

    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "updateHeaderFooterActive",
        element: targetElement,
        pageid: this.props.currentPage,
        active: event.target.checked,
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          GKEvent.updateActiveHeader(targetElement, result.data.value);

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        console.error("Error ajax");
      });
  };

  _switchActive = () => {
    return (
      !this._isNotAllowed() && (
        <div className="switch">
          <Switch
            checked={this.state.active}
            onChange={this._changedActive}
            value="active"
            inputProps={{ "aria-label": "Active" }}
          />
        </div>
      )
    );
  };

  _blockOverlay = (cb = () => {}) => {
    return (
      <div
        className={`header-overlay ${!this._isNotAllowed() ? "clickable" : ""}`}
      >
        {!this._isNotAllowed() && (
          <div>
            <button
              onClick={() => {
                if (!this._isNotAllowed()) cb();
              }}
              className="gk-button gk-small gk-primary gk-default"
            >
              <span>
                {l("Click to edit ") +
                  this.targetLabels[this.props.element] +
                  l(" layout")}
              </span>
            </button>
            {this.props.element === "header" && (
              <button
                onClick={() => this.props.editFloatCart()}
                className="gk-button gk-small gk-secondary gk-default"
              >
                <span>{l("Click to edit Float Cart")}</span>
              </button>
            )}
          </div>
        )}
      </div>
    );
  };

  _isNotAllowed = () => {
    for (const iterator of this.notAllowedPages) {
      if (
        this.props.currentPage.includes(iterator) ||
        this.props.currentPage === iterator
      )
        return true;
    }
    return false;
  };
  _renderHeader = () => {
    const { showSearch = false, showLogin = false } =
      this.props.appearanceSettings;
    return (
      <div style={{ position: "relative" }} className="header-footer">
        {this._switchActive()}

        <div
          className={`main-header ${
            this.state.active ? "active" : "inactive"
          } ${this.state.type == "none" ? "empty" : "not-empty"}`}
        >
          {this.state.type === "none" && <span>{l("Select header type")}</span>}
          {this.state.type !== "none" && this.state.html !== "" && (
            <>
              <Frame
                scrolling="no"
                style={{
                  height:
                    (this.headerHeights &&
                      this.headerHeights[this.state.type] &&
                      this.headerHeights[this.state.type][
                        this.props.currentDevice
                      ]) ||
                    123,
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: this.state.html }}
                ></div>
              </Frame>
            </>
          )}
        </div>

        {/* <SelectHeaderFooter
          open={this.state.open}
          onClose={this._toggleDialog}
          value={this.state.type}
        /> */}

        {this._blockOverlay(() => {
          // this._toggleDialog(true);
          this.props.editElement();
        })}
      </div>
    );
  };

  _renderPayload = (target) => {
    return (
      <div style={{ position: "relative" }} className={`header-footer`}>
        {target === "footer" && this._switchActive()}

        {this._blockOverlay(() => {
          this.props.editLayout();
        })}

        <div className={this.state.active ? "active" : "inactive"}>
          {(this.props.fetchedPayloads[target] &&
            this.props.fetchedPayloads[target].length > 0 &&
            this._previewCanvas(this.props.fetchedPayloads[target])) ||
            this._emptyCanvas(target)}
        </div>
      </div>
    );
  };

  _previewCanvas = (payload) => {
    return (
      <Preview state={payload}>
        {({ children }) => <div>{children}</div>}
      </Preview>
    );
  };

  _emptyCanvas = (target) => {
    if (target === "top_bar")
      return (
        <Container fluid className="empty-topbar">
          <Row>
            <Col md={4}>
              <p style={{ lineHeight: "26px", textAlign: "left" }}>
                <Skeleton count={1} height={12} width={250} />
              </p>
            </Col>
            <Col md={4}>
              <p style={{ lineHeight: "26px", textAlign: "center" }}>
                <Skeleton count={1} height={12} width={250} />
              </p>
            </Col>
            <Col md={4}>
              <ul style={{ float: "right" }}>
                <li style={{ marginRight: 4, display: "inline-block" }}>
                  <Skeleton circle width={24} height={24} />
                </li>
                <li style={{ marginRight: 4, display: "inline-block" }}>
                  <Skeleton circle width={24} height={24} />
                </li>
                <li style={{ marginRight: 4, display: "inline-block" }}>
                  <Skeleton circle width={24} height={24} />
                </li>
                <li style={{ marginRight: 4, display: "inline-block" }}>
                  <Skeleton circle width={24} height={24} />
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      );
    else if (target === "footer")
      return <Container fluid className="empty-footer"></Container>;
  };

  render() {
    if (this.props.element === "top_bar" || this.props.element === "footer")
      return this._renderPayload(this.props.element);
    else if (this.props.element === "header") return this._renderHeader();
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderFooter);
